import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { formValueSelector } from 'redux-form'
import Field from 'redux-form/lib/Field'

import { formatCurrency } from '../../../../service/i18n/format-currency.service'
import { LoadingSpinner } from '../../../../legacy/views/helpers/loading/spinner'
import { Card } from '../../../../component-library/components/card/card.component'
import {
  StyledHeading,
  StyledSubheading,
  StyledTotal,
  StyledError,
  StyledPaymentWrapper,
  LoadingContainer,
} from './payment-summary.component.styles'
import BET_4052 from 'ggx-src/feat/BET_4052/index.js'
import { ConnectedPaymentMethodSelection } from '../../../../payment/payment-method-selection.component'
import { getTotalCredit } from '../../../../billing/duck/selectors'

import { getFeatureFlag } from 'ggx-service/feature-flag/selectors'
import { displayAlert } from 'ggx-componentlibrary/components/alerts/alerts.component'
import { PaymentMethodModal } from 'ggx-src/van-booking/order/sidebar/order-form/summary/payment-method/payment-method-modal/payment-method-modal.component'
import RightIconSVG from 'ggx-src/van-booking/order/sidebar/order-form/summary/payment-method/assets/right_icon.svg'
import { Body } from 'ggx-componentlibrary/design/typography/typography.styles'
import {
  getSavedCardInfo,
  getStripeCards,
} from 'ggx-src/payment/duck/selectors'
import { CreditCardDisplay as NewCreditCardDisplay } from 'ggx-src/van-booking/order/sidebar/order-form/summary/payment-method/credit-card-display.component'
import { Wallet } from 'ggx-src/payment/wallet/wallet.multiple.cards.component'
import getCountry from 'ggx-src/legacy/views/helpers/get_country'

class PaymentSummaryForm extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    quotation: PropTypes.object,
    quotationLoading: PropTypes.bool,
    quotationMeta: PropTypes.shape({
      error: PropTypes.string,
    }),
    input: PropTypes.shape({
      onChange: PropTypes.func.isRequired,
    }).isRequired,
    t: PropTypes.func,
    paymentType: PropTypes.string,
    totalCredit: PropTypes.number,
    savedCardInfo: PropTypes.object,
    stripeCards: PropTypes.array,
  }

  static defaultProps = {
    quotation: {
      breakdown: [],
      total: 0,
    },
    quotationLoading: false,
    quotationMeta: {},
  }

  state = {
    show: false,
  }

  handlePaymentMethodChange = paymentMethod => {
    this.props.input.onChange(paymentMethod)
  }

  getDisplayedPaymentMethod(selectedPaymentMethod) {
    switch (selectedPaymentMethod) {
      case 'cash':
        return this.props.t('payment.paymentMethods.cash')
      case 'cash_credit':
        return this.props.t('common__monthly_settlement')
      case 'prepaid_wallet':
        return `${this.props.t('common__wallet')} (${formatCurrency({
          amount: this.props.totalCredit,
        })})`
      default:
        if (selectedPaymentMethod.startsWith('credit_card')) {
          const id =
            Number(selectedPaymentMethod.replace('credit_card_', '')) ||
            this.props.savedCardInfo.id
          const card = this.props.stripeCards.find(card => card.id === id)
          if (card)
            return (
              <NewCreditCardDisplay
                nickname={card.nickname}
                brand={card.brand}
                last4={card.last4}
                isExpired={card.is_expired}
                noBorderDisplayMode
              />
            )
        }
        return this.props.t('status__pay_with__not_selected')
    }
  }

  render() {
    const {
      className,
      quotation,
      quotationLoading,
      quotationMeta,
      t,
      paymentType,
      totalCredit,
    } = this.props
    const quotationBreakdown = quotation.breakdown
    const hasQuotation = quotation.total !== 0
    const paymentMethods = ['credit_card', 'prepaid_wallet']
    const defaultPaymentMethod =
      totalCredit > 0 ? 'prepaid_wallet' : paymentMethods[0]

    return (
      <div ref={this.createCardRef}>
        <Card className={className}>
          {quotationLoading ? (
            <LoadingContainer>
              <LoadingSpinner />
            </LoadingContainer>
          ) : (
            <div>
              <StyledHeading>
                {t('orderDetails.shippingInfo.priceBreakdown.total')}
              </StyledHeading>
              <StyledTotal total={quotation.total}>
                {formatCurrency({ amount: quotation.total })}
              </StyledTotal>
              {hasQuotation && (
                <div>
                  <StyledSubheading>
                    {t('orderDetails.title.shippingInfo.priceBreakdown.name')}
                  </StyledSubheading>
                  <BET_4052.OrderPriceBreakdown
                    additionalCharges={quotationBreakdown}
                    total={quotation.total}
                    discount={quotation.discount}
                  />
                </div>
              )}
            </div>
          )}
          {quotationMeta.error && (
            <StyledError>{quotationMeta.error}</StyledError>
          )}
          <StyledPaymentWrapper>
            {getCountry() === 'HK' || getCountry() === 'SG' ? (
              <>
                <StyledHeading onClick={() => this.setState({ show: true })}>
                  {t('orders.new.basicInfo.subtitle.payWith')}
                  <RightIconSVG />
                </StyledHeading>
                {this.state.show && (
                  <PaymentMethodModal
                    handleModalClose={() => this.setState({ show: false })}
                    selectedPaymentMethod={paymentType || defaultPaymentMethod}
                    setSelectedPaymentMethod={this.handlePaymentMethodChange}
                    sufficientBalance={totalCredit > Number(quotation.total)}
                    availablePaymentMethods={paymentMethods}
                  />
                )}

                <Body typographyStyles="mb-none c-grey_dark">
                  {this.getDisplayedPaymentMethod(
                    paymentType || defaultPaymentMethod
                  )}
                </Body>
                <Field
                  component={Wallet}
                  name="hasSufficientBalance"
                  openModal={false}
                  orderQuotation={parseInt(quotation.total, 10)}
                  prepaidBalance={totalCredit}
                  hideDisclaimers={false}
                  showMessage={
                    (paymentType || defaultPaymentMethod) === 'prepaid_wallet'
                  }
                />
              </>
            ) : (
              <>
                <StyledHeading>
                  {t('orders.new.basicInfo.subtitle.payWith')}
                </StyledHeading>
                <ConnectedPaymentMethodSelection
                  paymentType={paymentType || defaultPaymentMethod}
                  options={paymentMethods}
                  onPaymentMethodChange={this.handlePaymentMethodChange}
                  orderQuotation={parseInt(quotation.total, 10)}
                />
              </>
            )}
          </StyledPaymentWrapper>
        </Card>
      </div>
    )
  }

  componentDidUpdate(prevProps) {
    if (this.props.featureFlagEnableCouponFeature) {
      const preDiscount =
        prevProps?.quotation?.discount?.user_vouchers?.[0]?.discount
      const curDiscount = this.props?.quotation?.discount?.user_vouchers?.[0]
        ?.discount
      if (preDiscount === undefined && typeof curDiscount === 'string')
        displayAlert({
          message: this.props.t('feedback__coupon_applied', {
            discount: formatCurrency({ amount: Math.abs(curDiscount) }),
          }),
          autoClose: true,
        })
    }

    if (getCountry() === 'HK' || getCountry() === 'SG') {
      if (this.props.paymentType !== this.props.input.value) {
        const paymentMethods = [
          `credit_card_${this.props.savedCardInfo?.id}`,
          'prepaid_wallet',
        ]
        const defaultPaymentMethod =
          this.props.totalCredit > 0 || !this.props.savedCardInfo?.id
            ? 'prepaid_wallet'
            : paymentMethods[0]
        const paymentNewValue = this.props.paymentType || defaultPaymentMethod
        this.handlePaymentMethodChange(paymentNewValue)
        if (
          paymentNewValue.startsWith('credit_card') &&
          this.props.stripeCards?.find(card => card.is_default)?.is_expired
        ) {
          displayAlert({
            message: this.props.t('error__card_expired_place_order'),
            type: 'error',
          })
        }
      }
    }
  }
}

const selector = formValueSelector('delivery-order')

const mapStateToProps = state => ({
  totalCredit: getTotalCredit(state),
  paymentType: selector(state, 'payment_type'),
  featureFlagEnableCouponFeature: getFeatureFlag({
    state,
    featureFlag: 'enable_coupon_feature',
  }),
  savedCardInfo: getSavedCardInfo(state),
  stripeCards: getStripeCards(state) ?? [],
})

const PaymentSummaryFormWithTranslation = withTranslation()(PaymentSummaryForm)
const ConnectedPaymentSummaryFormWithTranslation = connect(mapStateToProps)(
  PaymentSummaryFormWithTranslation
)

export {
  PaymentSummaryFormWithTranslation,
  ConnectedPaymentSummaryFormWithTranslation,
}
